import request from './request'

// 兑换礼品码
export const codeExchange = (params: any) =>
  request({
    url: '/carbon-promotion/private/user/activity/redeem/code/redeem',
    method: 'POST',
    data: params,
  })
